import { createSlice } from "@reduxjs/toolkit";
import { showNotification } from "../../components/Notification";
import { createDesignation, deleteDesignation, getAllDesignation, updateDesignation } from "../../api/designationApi";


const initialState = {
  designation: [],
  loading: false,
  status: "idle", // 'idle' | 'loading' | 'succeeded' | 'failed'
};


const designationSlice = createSlice({
  name: "designation",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllDesignation.pending, (state) => {
        state.loading = true;
        state.status = "loading";
      })
      .addCase(getAllDesignation.fulfilled, (state, action) => {
        state.loading = false;
        state.status = "succeeded";
        state.designation = action.payload;
      })
      .addCase(getAllDesignation.rejected, (state, action) => {
        state.loading = false;
        state.status = "failed";
        state.error = action.payload;
        showNotification("error",action.payload?.message);
      })
      .addCase(createDesignation.pending, (state) => {
        state.loading = true;
        state.status = "loading";
      })
      .addCase(createDesignation.fulfilled, (state, action) => {
        state.loading = false;
        state.status = "succeeded";
        state.designation = [...state.designation, action.payload];
        showNotification("success", "Job Title Added Successfully");
      })
      .addCase(createDesignation.rejected, (state, action) => {
        state.loading = false;
        state.status = "failed";
        state.error = action.payload;
        showNotification(
          "error",
          action.payload?.message
        );
      })
      .addCase(deleteDesignation.pending, (state) => {
        state.loading = true;
        state.status = "loading";
      })
      .addCase(deleteDesignation.fulfilled, (state, action) => {
        state.loading = false;
        state.status = "succeeded";
        state.designation = state.designation.filter(
          (item) => item.id !== action.payload
        );
        showNotification("success", "Job Title Deleted Successfully");
      })
      .addCase(deleteDesignation.rejected, (state, action) => {
        state.loading = false;
        state.status = "failed";
        state.error = action.payload;
        showNotification(
          "error",
          action.payload?.message
        );
      })
      .addCase(updateDesignation.pending, (state) => {
        state.loading = true;
        state.status = "loading";
      })
      .addCase(updateDesignation.fulfilled, (state, action) => {
        state.loading = false;
        state.status = "succeeded";
        state.designation = state.designation.map((design) =>
          design?.id === action.payload?.id ? action.payload : design
        );
        showNotification("success", "Job Title Updated Successfully");
      })
      .addCase(updateDesignation.rejected, (state, action) => {
        state.loading = false;
        state.status = "failed";
        state.error = action.payload;
        showNotification(
          "error",
          action.payload?.message
        );
      });
  },
});

export const getDesignationState = (state) => state.designationState;
export const getDesignation = (state) => state.designationState.designation;

export default designationSlice.reducer;
